import * as o from "react";
import e from "../lib/IconBase.es.js";
import r from "../defs/RowsPlusBottom.es.js";
const t = o.forwardRef((s, m) => /* @__PURE__ */ o.createElement(e, { ref: m, ...s, weights: r }));
t.displayName = "RowsPlusBottomIcon";
const n = t;
export {
  n as RowsPlusBottom,
  t as RowsPlusBottomIcon
};
